export default (itemNumber) => {
    const trimmed = typeof itemNumber === 'string' ? itemNumber.trim() : ''
    if (!trimmed) return false

    const barcode = trimmed.includes('#') ? trimmed : '#' + trimmed

    const regex = /#(\d+)_(\d+)/gi
    const parsed = regex.exec(barcode)

    if (!parsed || parsed.length !== 3) return false

    const [flag, number, index] = parsed

    const vNumber = parseInt(number, 10)
    const vIndex = parseInt(index, 10)

    return {
        flag: flag,
        number: vNumber > 0 ? vNumber : 0,
        index: vIndex > 0 ? vIndex : 0,
    }
}